
<p><b>GUID is:</b> {{ guid }}</p>

<p *ngIf="this.token"><b>Token is:</b><small>{{ this.token }}</small></p>
